import io from 'socket.io-client';
import socketio from '@feathersjs/socketio-client';
import feathers from '@feathersjs/feathers';
import config from '../config/global';

const client = feathers();
export const socket = io(config.SERVER_URL);
client.configure(socketio(socket, {timeout: 10000}));

export default client;